export default __webpack_public_path__ + "static/media/successful.e889853c.svg";